import request from '@/utils/request';
export async function get(payload) {
  return request(`/iwms-wms/wms/progress?jobName=${payload.jobName}&instanceId=${payload.instanceId}`)
}
